// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QCV9","col":"styles_col__At5DG"};